import { forwardRef } from 'react'
import { useSelector } from 'react-redux'

import TaskMesh, { type TaskMeshProps } from '~/components/common/TaskMesh'
import type { TaskContext } from '~/constants/taskConstants'
import { getTaskWithChildren } from '~/store/reducers/tasks'
import { isWithinTimeInterval } from '~/utils/time'

import TaskStateButtonDetailed from './TaskStateButtonDetailed'

export interface TaskStateButtonMeshProps extends TaskMeshProps {
  context: TaskContext
  taskId: string
}

const TaskStateButtonMesh = forwardRef<
  HTMLDivElement,
  TaskStateButtonMeshProps
>(function TaskStateButtonMesh({ taskId, context, ...rest }, ref) {
  const tasks = useSelector(getTaskWithChildren(taskId))

  return (
    <TaskMesh ref={ref} {...rest}>
      {(column) => {
        const tasksInThisSlot = tasks.filter((task) =>
          isWithinTimeInterval(task?.dueDate, column),
        )

        return tasksInThisSlot.map((task) => (
          <TaskStateButtonDetailed
            context={context}
            key={task.id}
            task={task}
          />
        ))
      }}
    </TaskMesh>
  )
})

export default TaskStateButtonMesh
